import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addTocart } from "../../redux/actions/cart";
import { useToast } from "../Layout/Toast/ToastProvider.jsx";
import { FaRegSadTear } from 'react-icons/fa';
import SubProductCard from "../Cards/SubProductCard";
import './ProductDetailsInfo.scss';

const ProductDetailsInfo = ({ data }) => {
  const [active, setActive] = useState(1);
  const { cart } = useSelector((state) => state.cart);
  const [count] = useState(1);
  const { showToast } = useToast();

  const dispatch = useDispatch();

  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 500;

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const addToCartHandler = (item) => {
    const itemIndex = cart.findIndex((i) => i._id === item._id);
  
    if (itemIndex !== -1) {
      const updatedItem = {
        ...cart[itemIndex],
        qty: cart[itemIndex].qty + 1,
      };
      dispatch(addTocart(updatedItem, itemIndex));
      showToast("Кількість товару в корзині збільшена!", "success");
    } else {
      const cartData = {
        ...item,
        originalPrice: item.price,
        discountPrice: item.discountPrice,
        qty: count,
      };
      dispatch(addTocart(cartData));
      showToast("Продукт успішно додано до корзини!", "success");
    }
  };
  
  return (
    <div className="product-details-info">
      <div className="pdi-header">
        <div
          className={`pdi-tab ${active === 1 ? 'pdi-tab--active' : ''}`}
          onClick={() => setActive(1)}
        >
          <h5 className="pdi-tab__title">Характеристики</h5>
        </div>
        {data.subProducts && data.subProducts.length > 0 && (
          <div
            className={`pdi-tab ${active === 2 ? 'pdi-tab--active' : ''}`}
            onClick={() => setActive(2)}
          >
            <h5 className="pdi-tab__title">Компоненти</h5>
          </div>
        )}
      </div>
      {active === 1 && (
        <div className="pdi-description-block">
          <p className="pdi-description">
            {isExpanded || data.description.length <= maxLength
              ? data.description
              : `${data.description.slice(0, maxLength)}...`}
          </p>
          {data.description.length > maxLength && (
            <button
              onClick={toggleReadMore}
              className="pdi-read-more"
            >
              {isExpanded ? 'Згорнути' : 'Читати далі'}
            </button>
          )}
        </div>
      )}
      {active === 2 && (
        <div className="pdi-subproducts">
          <div className="pdi-subproducts__grid">
            {data.subProducts && data.subProducts.length > 0 ? (
              data.subProducts.map((subProduct, index) => (
                <SubProductCard
                  key={index}
                  subProduct={subProduct}
                  addToCartHandler={addToCartHandler}
                />
              ))
            ) : (
              <div className="pdi-subproducts__empty">
                <FaRegSadTear className="pdi-subproducts__empty-icon" />
                <p>Для цього продукту немає доступних компонентів</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDetailsInfo;